import React from 'react';
import s from 'styled-components';
import cn from 'classnames';
import { Link } from 'components/typo';
import * as PathsTypes from 'constants/PathsTypes';

// images
import imgLogo from 'assets/images/logo.svg';

// constants

const styles = ({
  theme,
  $size,
  $isNoMobile,
  $defaultStyle = 'light',
}) => {
  const componentTheme = theme.components.logo;
  const sizes = componentTheme.sizes[$size] || componentTheme.sizes.normal;
  const mobSizes = componentTheme.sizes.small;
  const styles = componentTheme.styles[$defaultStyle] || componentTheme.styles.light;

  return `
    display: inline-flex;
    align-items: center;

    img {
      width: ${sizes.width};
      height: ${sizes.height};

      @media (max-width: 768px) {
        width: ${$isNoMobile ? sizes.width : mobSizes.width};
        height: ${$isNoMobile ? sizes.height : mobSizes.height};
      }
    }

    span {
      color: ${styles.color};
      transition: 0.3s color ease-in-out;

      @media (max-width: 768px) {
        font-size: 14px;
      }
    }


    &:hover {
      span {
        color: ${styles.colorHover || styles.color};
      }
    }
  `;
};

const LogoContainer = s.div`
  ${(props) => styles(props)}
`;

const Logo = ({
  nopointers = false,
  className = '',
  size = 'normal',
  isNoMobile = false,
  defaultStyle,
}) => {
  const logo = (
    <LogoContainer
      $isNoMobile={isNoMobile}
      $size={size}
      $defaultStyle={defaultStyle}
      className={cn('w-logo', className)}
    >
      <img
        alt="TomYumBar"
        src={imgLogo}
        width="66"
        height="66"
      />
    </LogoContainer>
  );

  const handleClick = (e) => {
    if (window.location.pathname === '/') {
      e.preventDefault();
      window.location.href = '/';
    }
  };

  return nopointers
    ? logo
    : (
      <Link
        noTransition
        display="inline-flex"
        to={PathsTypes.HOME}
        onClick={handleClick}
      >
        {logo}
      </Link>
    );
};

export default Logo;
